<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="para">An average camp meeting consisted of a formulaic assembly of veterans, probably not unlike that held monthly by the Captain James H. Bradford Camp of San Antonio, Texas. “After the camp is called to order while all the members stand at attention, ‘America’ is sung and the invocation asked by the [camp’s] chaplain. Then follow the salute of the colors, reading of minutes and [consideration of] applications for membership. Each candidate is required to repeat an ‘Obligation of Candidates,’ in which he pledges loyalty to his country and obedience to its laws, defense in time of danger and allegiance to his comrades of the Indian wars. After other business is attended to, the meeting closes with a patriotic song, the salute of the colors, and a benediction.”<span href="#/IndianWarVeterans_notes#I616" id="I6_16" title="Link target outside of Sample"><sup><span class="font01">16</span></sup></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_introduction6.vue?5dadcb46